// Router Account
export default [
  {
    path: '/login',
    name: 'login',
    component: () => {
      if (process.env.VUE_APP_COMPONENT_LOGIN) {
        return import(
          /* webpackChunkName: "customComponents" */ process.env.VUE_APP_COMPONENT_LOGIN
        );
      }
      return null;
    },
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_COMPONENT_LOGIN) {
        // check if user doesn't have token or redirect to dashboard
        const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
          ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
          : null;
        if (storage && storage.user && storage.user.user && storage.user.user.uuid) {
          next({ name: 'dashboard' });
        } else {
          next();
        }
      } else {
        next({ name: 'dashboard' });
      }
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import(/* webpackChunkName: "account" */ '../../views/account/passwordReset/PasswordReset.vue'),
    beforeEnter: (to, from, next) => {
      // check if user doesn't have token or redirect to dashboard
      const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
        ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
        : null;
      if (storage && storage.user && storage.user.user && storage.user.user.uuid) {
        next({ name: 'dashboard' });
      } else {
        next();
      }
    },
  },
  {
    path: '/account/password/reset/:uid64/:token',
    name: 'resetPasswordNew',
    component: () => import(/* webpackChunkName: "account" */ '../../views/account/passwordReset/PasswordResetNew.vue'),
    beforeEnter: (to, from, next) => {
      // check if user doesn't have token or redirect to dashboard
      const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
        ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
        : null;
      if (storage && storage.user && storage.user.user && storage.user.user.uuid) {
        next({ name: 'dashboard' });
      } else {
        next();
      }
    },
  },
  {
    path: '/account/unlock/:uid64/:token',
    name: 'accountUnlock',
    component: () => import(/* webpackChunkName: "account" */ '../../views/account/accountUnlock/accountUnlock.vue'),
    beforeEnter: (to, from, next) => {
      // check if user doesn't have token or redirect to dashboard
      const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
        ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
        : null;
      if (storage && storage.user && storage.user.user && storage.user.user.uuid) {
        next({ name: 'dashboard' });
      } else {
        next();
      }
    },
  },
  {
    path: '/account/unknown-ip/:uid64/:token',
    name: 'accountUnknownIp',
    component: () => import(/* webpackChunkName: "account" */ '../../views/account/accountSecurity/AccountSecurity.vue'),
  },
];
